/**
 * Invoice Upload Endpoints
 */
export const INVOICE_UPLOAD_ENDPOINTS = {
  saveConfiguration: 'bill-upload-config/save',
  getFieldMaster: 'bill-upload-config/get-field-master',
  listCampaigns: 'bill-upload-config/list-campaigns',
  enableDisableCampaign: 'invoice/enable_disable',
  getUserTypes: 'enrollment-onboarding/get-user-types',
  getUserGroups: 'enrollment-onboarding/get-user-groups',
  getCampaign: 'bill-upload-config/get-campaign',
  getAllData: 'enrollment-setting/get-all-data',
} as const;
